import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SharedDataService } from '../share-data/share-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

    private userSettings$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public userSettingsState$ = this.userSettings$.asObservable();

    constructor(
       private sharedDataService: SharedDataService
    ) {
      this.initialState();
    }

    initialState() {
      let initialState = this.sharedDataService.getStoredData() || false;
      this.userSettings$.next(initialState);
    }
    setState(state: boolean,key:string) {
      this.sharedDataService.storeData({
        name: key,
        data: state
      });
    }
    clearState(key?:string) {
      this.userSettings$.next(false);
      this.sharedDataService.removeStoredData(key);
    }
  getState(key?: string) {
    if(!key){
      return this.sharedDataService.getStoredData(key);
    }
    return this.userSettings$.getValue();
    }
}
